import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * 正誤情報取得
 */
export namespace ApiTaSf050 {
  // API Name
  export const name: string = 'ApiTaSf050'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/correctWrongInfo'

    export interface Request {
      query: {
        unitId: string
        pieceId: string
        contentCategory: number[]
      }
    }

    export interface Response {
      unitAnswerList: {
        examNumber: string
        correction: string
      }[]
    }
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        unitAnswerList: [
          {
            examNumber: '',
            correction: '',
          },
        ],
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
